import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../services/apiService";

const COUNTRY_SELECT_GET_COUNTRIES = "countrySelectField/getCountries";

export const getCountries = createAsyncThunk(
  COUNTRY_SELECT_GET_COUNTRIES,
  async (payload, { rejectWithValue }) => {
    const { token } = payload;
    const url = `/countries`;
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await get(url, config);
      const rows = data?.data ?? data ?? [];
      return {
        countries: rows.map(({ country_alpha2, country_name }) => ({
          value: country_alpha2,
          label: country_name,
        })),
      };
    } catch (error) {
      console.error("Error getting countries thunk:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
